export default __webpack_public_path__ + "static/media/gauge.52b29352.png";